package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.views.AppTheme

@Composable
fun ComingSoonWebView() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(AppTheme.current.colors.background),
        contentAlignment = Alignment.Center
    ) {
        Texts.HeadlineSmall(
            text = "Comming soon",
            color = AppTheme.current.colors.onSurface
        )
    }
}
